import { GeneralObject } from "../definitions/general";

export const processCancellationPolicies = (
  data: GeneralObject[]
): GeneralObject[] => {
  const policies = [...data];

  return policies
    .filter((policy) => policy.start_date == null && policy.end_date == null)
    .sort((a, b) => {
      const aMin = a.min_days_before_checkin ?? -Infinity;
      const bMin = b.min_days_before_checkin ?? -Infinity;
      return bMin - aMin;
    });
};
